<template>
  <div>
    <BootstrapDialog
      title="套餐审核"
      ref="dialog"
      size="lg"
      :modalStyle="{ width: '1000px' }"
      @afterClose="afterClose()"
    >
      <template v-slot:body>
        <div class="panel-body">
          <div class="row">
            <div class="modal-body wrapper-lg" style="width:100%">
              <div class="row" style="padding-right:10px">
                <div class="col-sm-12 col-sm-offset-0">
                  <form role="form" class="form-horizontal">
                    <div class="form-group">
                      <label class="col-sm-2 control-label">套餐名称</label>
                      <div class="col-sm-5">
                        <div></div>
                        <input
                          disabled
                          type="text"
                          v-model="model.tcmc"
                          name="tcmc"
                          v-validate="{ required: true, max: 50 }"
                          data-vv-as="用户名"
                          class="form-control"
                          placeholder=""
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">学历类型</label>
                      <div class="col-sm-5">
                        <select
                          disabled
                          class="form-control"
                          v-model="model.xllx"
                          name="js"
                          v-validate="{ required: true }"
                          data-vv-as="用户角色"
                        >
                          <option value="">--请选择--</option>
                          <option
                            v-for="xllx in xllxArr"
                            :value="xllx.value"
                            :key="xllx.value"
                            >{{ xllx.text }}</option
                          >
                        </select>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">报考范围</label>
                      <div class="col-sm-8" v-if="model.ranges != 0">
                        <table style="backgroundColor:#F5F5F5;">
                          <thead>
                            <tr>
                              <th>主考学校</th>
                              <th>专业层次</th>
                              <th>学科</th>
                              <th>选择专业</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in model.ranges"
                              :key="index + 'a'"
                            >
                              <td>

                                
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="zkxxArr"
                                  value-field="id"
                                  text-field="jgmc"
                                  v-model="item.zkxxId"
                                  :formatOption="
                                    (zkxx) => zkxx.jgdm + '-' + zkxx.jgmc
                                  "
                                ></BootstrapCombobox>
                              </td>

                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="zyccArr"
                                  value-field="value"
                                  text-field="text"
                                  v-model="item.zycc"
                                  :format-option="(zycc) => zycc.text"
                                  @change="zyccChange(item)"
                                ></BootstrapCombobox>
                              </td>

                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="xkArr"
                                  value-field="id"
                                  text-field="xkmc"
                                  v-model="item.xkId"
                                  :formatOption="
                                    (xk) => xk.xkdm + '-' + xk.xkmc
                                  "
                                  @change="xkIdChange(item)"
                                ></BootstrapCombobox>
                              </td>

                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="item.zyArr"
                                  value-field="id"
                                  text-field="xkmc"
                                  v-model="item.zyId"
                                  :format-option="
                                    (zy) => zy.zydm + '-' + zy.zymc
                                  "
                                ></BootstrapCombobox>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">注册范围</label>
                      <div class="col-sm-8" v-if="model.regRanges != 0">
                        <table
                          style="width:800px;margin:0 auto;backgroundColor:#F5F5F5;border: 1px soild #696969"
                        >
                          <thead>
                            <tr>
                              <th>套餐限制类型</th>
                              <th>限制类型</th>
                              <th></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in model.regRanges"
                              :key="index + 'b'"
                            >
                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="xzlxArr"
                                  value-field="value"
                                  text-field="text"
                                  v-model="item.xzlx"
                                  :formatOption="(xzlx) => xzlx.text"
                                  @change="xzlxChange(item)"
                                ></BootstrapCombobox>
                              </td>
                              <td>
                                <BootstrapCombobox
                                  :enabled="false"
                                  :data="item.xzzArr"
                                  value-field="id"
                                  text-field="mc"
                                  v-model="item.xzz"
                                  :formatOption="(xzz) => xzz.mc"
                                ></BootstrapCombobox>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">收费标准</label>
                      <div class="col-sm-10">
                        <table style="backgroundColor:#F5F5F5;">
                          <thead>
                            <tr>
                              <th>收费项目</th>
                              <th>收费金额</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in model.amounts"
                              :key="index + 'd'"
                            >
                              <td>
                                <select
                                  disabled
                                  class="form-control"
                                  v-model.number="item.sflx"
                                  name="js"
                                  v-validate="{ required: true }"
                                  data-vv-as="用户角色"
                                >
                                  <option value="">--请选择--</option>

                                  <option
                                    v-for="(sflx, index) in sflxArr"
                                    :value="sflx.value"
                                    :key="index + 'c'"
                                    >{{ sflx.text }}</option
                                  >
                                </select>
                              </td>
                              <td>
                                <input
                                  disabled
                                  type="text"
                                  v-model="item.sfje"
                                  class="form-control"
                                  placeholder=""
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <!--保存-->
            <div class="col-sm-12 text-center">
              <div class="form-group">
                <button
                  @click="pass()"
                  type="button"
                  class="btn btn-primary btn-sm "
                  style="margin-right:16px; background-color: #3CB371;border:none"
                >
                  审核通过
                </button>
                <button
                  @click="nopass()"
                  type="button"
                  class="btn btn-primary btn-sm "
                  style="background-color: #FF0000;border:none"
                >
                  审核拒绝
                </button>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          style="margin-left:10px"
          class="btn btn-default"
          type="button"
          @click="close()"
        >
          关闭
        </button>
      </template>
    </BootstrapDialog>
  </div>
</template>

<script>
import { xllx, sflx, zycc, xzlx } from "@/plugins/enums.js";

export default {
  name: "PackageMgCheck",
  components: {},
  data: function() {
    return {
      xzlxArr: [],
      //主考学校下拉
      zkxxArr: [],
      // 专业层次下拉
      zyccArr: [],
      //  学科下拉
      xkArr: [],
      // 选择专业下拉
      zyArr: [],
      // isShow: false,
      // 收费类型
      sflxArr: [],
      model: {
        tcmc: null,
        xllx: null,
        ranges: [],
        regRanges: [
          {
            xzlx: null,
            xzz: null,
            xzzArr: [],
          },
        ],
        amounts: [
          {
            sflx: null,
            sfje: null,
          },
        ],
      },
      // 学历类型下拉
      xllxArr: [],
      tcId: null,
    };
  },
  async created() {},
  methods: {
    // 不通过
    nopass() {
      let obj = {
        id: this.model.id,
        status: "NOT_PASS",
      };
      this.$http.post("/htgl/biz/cw/tc/verify", obj).then((res) => {
        if (res.data) {
          this.$success("操作成功", () => {
            this.close();
            this.$parent.search(); //刷新列表
          });
        }
      });
    },
    // 通过
    pass() {
      let obj = {
        id: this.model.id,
        status: "PASS",
      };
      this.$http.post("/htgl/biz/cw/tc/verify", obj).then((res) => {
        if (res.data) {
          this.$success("操作成功", () => {
            this.close();
            this.$parent.search(); //刷新列表
          });
        }
      });
    },
    async open(row) {
      this.xllxArr = xllx;
      this.sflxArr = sflx;
      this.model.tcmc = row.tcmc;
      this.model.xllx = row.xllx;
      this.model.id = row.id;
      this.tcId = row.id;

      this.zyccArr = zycc;
      this.zkxx();
      this.xk();
      this.xzlxArr = xzlx;

      // 收费标准数据
      let res1 = await this.$http.post("/htgl/biz/cw/tc/sfbz/getByTcId", {
        tcId: row.id,
      });
      if (res1) {
        this.model.amounts = res1.data;
      }
      // 报考范围
      let res2 = await this.$http.post("/htgl/biz/cw/tc/bkfw/getByTcId", {
        tcId: row.id,
      });
      if (res2) {
        this.model.ranges = res2.data;
        this.model.ranges.forEach((li, m) => {
          this.xzlxChange(li);
          this.xkIdChange(li);
        });
      }

      // 报考范围
      let res3 = await this.$http.post("/htgl/biz/cw/tc/zcfw/getByTcId", {
        tcId: row.id,
      });
      if (res3) {
        this.model.regRanges = res3.data;
        this.model.regRanges.forEach((li, m) => {
          this.xzlxChange(li);
          this.xkIdChange(li);
        });
      }
      this.$refs.dialog.open();
      // alert(2)
    },
    zyccChange(item) {
      this.$http
        .post("/htgl/inf/zy/cx", {
          zycc: item.zycc,
          xkId: item.xkId,
        })
        .then((res) => {
          item.zyArr = res.data.records;
        });
    },

    xkIdChange(item) {
      this.$http
        .post("/htgl/inf/zy/cx", {
          zycc: item.zycc,
          xkId: item.xkId,
        })
        .then((res) => {
          item.zyArr = res.data.records;
        });
    },
    xzlxChange(item) {
      let poUrl = "/htgl/biz/cw/tc/limit";
      this.$http.post(poUrl, { xzlx: item.xzlx }).then((res) => {
        item.xzzArr = res.data;
      });
    },
    sendXzfwData(e) {
      this.model.regRanges = [...this.model.regRanges, ...e];
    },
    // 报考范围
    sendFwData(e) {
      this.model.ranges = [...this.model.ranges, ...e];
    },
    delRanges(index) {
      this.model.ranges.splice(index, 1);
    },
    delregRanges(index) {
      this.model.regRanges.splice(index, 1);
    },

    // 选择专业下拉
    zy() {
      this.$http.post("/htgl/inf/zy/cx", { size: 9999 }).then((res) => {});
    },

    // 学科下拉数据
    xk() {
      this.$http.post("/htgl/inf/xk/cx", { size: 9999 }).then((res) => {
        this.xkArr = res.data.records;
      });
    },
    // 主考学校下拉数据
    zkxx() {
      this.$http
        .post("/htgl/sys/jg/cx", { jglx: "ZKXX", size: 9999 })
        .then((res) => {
          this.zkxxArr = res.data.records;
          console.log;
        });
    },

    // 删除
    del(index) {
      this.model.amounts.splice(index, 1);
    },
    //  点击添加
    add() {
      let obj = {
        sflx: null,
        sfje: null,
      };
      this.model.amounts.push(obj);
    },
    //选择注册范围
    toUserChoose() {
      this.$refs.PackageMgUserchooseEdit.open();
    },

    reset: function() {
      this.model = {
        tcmc: null,
        xllx: null,
        ranges: [],
        regRanges: [],
        amounts: [
          {
            sflx: null,
            sfje: null,
          },
        ],
      };
    },

    close: function() {
      this.$refs.dialog.close();
    },
    afterClose: function() {
      this.$validator.reset();
      this.reset();
    },

    save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let poUrl = "/htgl/biz/cw/tc/update";
          this.$http
            .post(poUrl, JSON.stringify(this.model), {
              "Content-Type": "application/json;charset=UTF-8",
            })
            .then((res) => {
              if (res.code == 0) {
                this.$success("操作成功", () => {
                  this.$router.push({ name: "PackageMg" });
                });
              }
            });
        }
      });
    },
  },
};
</script>
<style scoped>
th,
td {
  height: 25px;
  padding: 5px 10px;
  line-height: 25px;
}
</style>
